import { render, staticRenderFns } from "./buildDetail.vue?vue&type=template&id=d3dd07b2&scoped=true&"
import script from "./buildDetail.vue?vue&type=script&lang=js&"
export * from "./buildDetail.vue?vue&type=script&lang=js&"
import style0 from "./buildDetail.vue?vue&type=style&index=0&id=d3dd07b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3dd07b2",
  null
  
)

export default component.exports